import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['firstModalContent', 'secondModalContent', 'thirdModalContent', 'suiteDropdown', 'trainingsDropdown', 'operationType', 'nameField', 'fileInfoDisplay', 'chooseFileDisplay', 'fileName'];

  connect() {
    $('#faqhead1').on('click', () => this.toggleTemplates(this.element));
    this.initializeRequiredFields();
    this.setupFileUploadListeners();
  }

  setupFileUploadListeners() {
    // Listen for file input change to add file to dropzone
    const fileInput = document.getElementById('policy-handbook-input');
    if (fileInput) {
      fileInput.addEventListener('change', (event) => {
        const file = event.target.files[0];
        if (file) {
          // Wait a bit for dropzone to be ready
          setTimeout(() => {
            const dropzoneElement = $(this.element).find('.dropzone')[0];
            if (dropzoneElement && dropzoneElement.dropzone) {
              dropzoneElement.dropzone.addFile(file);
            }
          }, 100);
        }
      });
    }

    // Setup dropzone event listeners with retry mechanism
    const setupDropzoneListeners = () => {
      const dropzoneElement = $(this.element).find('.dropzone')[0];
      if (dropzoneElement && dropzoneElement.dropzone) {
        dropzoneElement.dropzone.on("success", (file, response) => {
          this.updateFileDisplay(file.name);
        });

        dropzoneElement.dropzone.on("addedfile", (file) => {
          if (file.accepted) {
            // File will be processed, wait for success event
          } else {
            // File was rejected, keep showing choose file UI
          }
        });
      } else {
        // Retry if dropzone not ready yet
        setTimeout(setupDropzoneListeners, 100);
      }
    };

    setupDropzoneListeners();
  }

  initializeRequiredFields() {
    const checkedRadio = $(this.element).find("[data-action='policies#toggleDropdown']:checked");
    if (checkedRadio.length === 0) return;

    const selection = checkedRadio.data('selection');

    if (selection === 'suite' && this.hasSuiteDropdownTarget) {
      $(this.suiteDropdownTarget).find('select').prop('required', true);
    } else if (selection === 'trainings' && this.hasTrainingsDropdownTarget) {
      $(this.trainingsDropdownTarget).find('select').prop('required', true);
    }
  }

  nextModal(event) {
    if ($(event.currentTarget).hasClass('disabled')) {
      event.preventDefault();
      return false;
    }

    event.preventDefault();
    let targetBtn = $(event.currentTarget);

    if (targetBtn.data('step') !== 2) {
      if (typeof hideModalClasses === 'function') {
        hideModalClasses();
      }
    }

    if (targetBtn.data('step') === 1) {
      $(this.firstModalContentTarget).hide();
      $(this.secondModalContentTarget).show();
    } else if (targetBtn.data('step') === 2) {
      if (typeof hideModalClasses === 'function') {
        hideModalClasses();
      }
      $(this.secondModalContentTarget).hide();
      $(this.thirdModalContentTarget).show();
    }

    $('#policyModal').modal('show');
  }

  previousModal(event) {
    event.preventDefault();
    if (typeof hideModalClasses === 'function') {
      hideModalClasses();
    }
    let targetBtn = $(event.currentTarget);

    if (targetBtn.data('step') === 2) {
      $(this.secondModalContentTarget).hide();
      $(this.firstModalContentTarget).show();
    } else if (targetBtn.data('step') === 3) {
      $(this.thirdModalContentTarget).hide();
      $(this.secondModalContentTarget).show();
    }

    $('#policyModal').modal('show');
  }

  toggleDropdown(event) {
    event.preventDefault();
    const selection = $(event.target).data('selection');
    const trainingsField = $(this.trainingsDropdownTarget).find('select');
    const suiteField = $(this.suiteDropdownTarget).find('select');
    const visibilityField = $('#visibility');

    // Hide all dropdowns by default
    $(this.suiteDropdownTarget).hide();
    suiteField.prop('required', false);

    $(this.trainingsDropdownTarget).hide();
    trainingsField.prop('required', false);

    // Reset fields that should be cleared
    if (selection !== 'trainings') {
      trainingsField.val(null).trigger('change');
    }

    if (selection !== 'suite') {
      suiteField.val(null).trigger('change');
    }

    // Set visibility based on selection
    visibilityField.val(selection !== 'visibility');

    // Show the appropriate dropdown based on selection
    if (selection === 'suite') {
      $(this.suiteDropdownTarget).show();
      suiteField.prop('required', true);
    } else if (selection === 'trainings') {
      $(this.trainingsDropdownTarget).show();
      trainingsField.prop('required', true);
    }
  }

  setOperationType(event) {
    let val = $(event.currentTarget).data('operationType')
    $(this.operationTypeTarget).val(val)
  }

  submitSearchForm(event) {
    let form = $(event.target).closest('#archived-form')[0]
    form.submit()
  }

  toggleTemplates(element) {
    const label = $(element).find('.toggle-label')[0]
    const accordion = $(element).find('.toggle-accordion')[0]
    if (label == undefined || accordion == undefined) {
      return
    }

    if ($(accordion).attr('aria-expanded') == 'true') {
      $(label).text('Hide Templates')
    } else {
      $(label).text('Show Templates')
    }
  }

  validateForm(event) {
    const field = event.currentTarget;
    const isValid = field.value.trim().length > 0;
    field.classList.toggle('is-invalid', !isValid);
  }

  handleFormValidation(event) {
    event.preventDefault();

    if ($('.learners-select').val().length == 0) {
      alert('Please select some learners.')
    } else {
      // Assuming hideModalClasses is a global function or needs to be safely called
      if (typeof hideModalClasses === 'function') {
        hideModalClasses();
      }
      if (typeof initializeDatePickers === 'function') {
        initializeDatePickers($('.daterangefull'));
      }
      $('#bulk-post-assign-policies').modal('show');
    }
  }

  chooseFile(event) {
    event.preventDefault();
    // Use Dropzone's built-in file input instead of the native one,
    // which has display:none set by the dropzone controller
    const dropzoneElement = $(this.element).find('.dropzone')[0];
    if (dropzoneElement && dropzoneElement.dropzone) {
      dropzoneElement.dropzone.hiddenFileInput.click();
    } else {
      console.error('Dropzone not found');
    }
  }

  changeFile(event) {
    event.preventDefault();
    if (this.hasFileInfoDisplayTarget) {
      $(this.fileInfoDisplayTarget).addClass('d-none');
    }
    if (this.hasChooseFileDisplayTarget) {
      $(this.chooseFileDisplayTarget).removeClass('d-none');
    }
    // Clear the file input
    const fileInput = document.getElementById('policy-handbook-input');
    if (fileInput) {
      fileInput.value = '';
    }
    // Remove any uploaded files from dropzone
    const dropzoneElement = $(this.element).find('.dropzone')[0];
    if (dropzoneElement && dropzoneElement.dropzone) {
      dropzoneElement.dropzone.removeAllFiles(true);
    }
  }

  updateFileDisplay(fileName) {
    if (this.hasFileNameTarget) {
      $(this.fileNameTarget).text(fileName);
    }
    if (this.hasFileInfoDisplayTarget) {
      $(this.fileInfoDisplayTarget).removeClass('d-none');
    }
    if (this.hasChooseFileDisplayTarget) {
      $(this.chooseFileDisplayTarget).addClass('d-none');
    }
  }
}
